import { Language } from './types';

export const CONTACT_INFO = {
    address: 'Laisvės al. 99-5B, LT-44291 Kaunas',
    phone: '+370 37 20 6938',
    phone2: '+370 682 38118',
    email: 'info@litteramagna.lt',
    facebook: 'https://www.facebook.com/LitteraMagna',
    linkedin: 'https://lt.linkedin.com/company/littera-magna',
    googleReview: 'https://g.page/r/CVfHEVzwprj2EBM/review',
    googleMapsEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d573.5749381206009!2d23.901444128615598!3d54.8976608694787!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x46e7220c63407333%3A0xf6b8a6f05c11c757!2sLittera%20Magna%2C%20UAB%20Skubus%20Vertimai%20Kaune!5e0!3m2!1sen!2sis!4v1772732359016!5m2!1sen!2sis',
    googleMapsDirections: 'https://www.google.com/maps/dir/?api=1&destination=Littera%20Magna%2C%20UAB%20Skubus%20Vertimai%20Kaune',
    appleMapsDirections: 'https://maps.apple.com/?daddr=Laisv%C4%97s%20al.%2099-5B%2C%20LT-44291%20Kaunas',
};

export const SERVICE_LANGUAGES = [
    { code: 'LT', name: 'Lietuvių', pricePerWord: 0.10 },
    { code: 'EN', name: 'English', pricePerWord: 0.12 },
    { code: 'LV', name: 'Latviešu', pricePerWord: 0.11 },
    { code: 'RU', name: 'Русский', pricePerWord: 0.15 },
    { code: 'PL', name: 'Polski', pricePerWord: 0.10 },
    { code: 'ET', name: 'Eesti', pricePerWord: 0.12 },
    { code: 'IT', name: 'Italiano', pricePerWord: 0.13 },
    { code: 'DE', name: 'Deutsch', pricePerWord: 0.12 },
    { code: 'UA', name: 'Українська', pricePerWord: 0.10 },
];

export const AVAILABLE_UI_LANG_CODES = ['LT', 'EN'];

export const OPERATING_MARKETS = [
    'LT', 'LV', 'EE', 'PL', 'CZ', 'SK', 'HU',
    'DE', 'FR', 'NL', 'BE', 'LU', 'AT', 'CH', 'LI',
    'DK', 'SE', 'NO', 'FI', 'IS', 'IE', 'GB',
    'ES', 'PT', 'IT', 'GR', 'CY', 'MT',
    'SI', 'HR', 'RO', 'BG',
    'AL', 'ME', 'MK', 'RS', 'BA',
    'MD', 'UA', 'GE', 'AM', 'AZ', 'TR', 'AE',
    'KZ', 'UZ', 'TJ',
    'US', 'CA'
];

export const HIGHLIGHTED_NEWS_SLUGS = [
    'certified-vs-notarized-translation-lithuania',
    'apostille-and-certified-translation-correct-order',
    'ai-in-legal-translation',
    'certified-translation-guide-2026',
    'expanding-nordic-languages'
];

export const UI_LANGUAGES = AVAILABLE_UI_LANG_CODES.map(code =>
    SERVICE_LANGUAGES.find(l => l.code === code)
).filter((l): l is Language => !!l);
